import { useState, useEffect } from "react";
import * as api from "../services/api";

export function useTools(category?: string) {
  const [tools, setTools] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    api.getTools(category)
      .then((data) => setTools(data.tools))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [category]);

  return { tools, loading, error };
}

export function useTool(slug: string) {
  const [tool, setTool] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!slug) return;
    setLoading(true);
    setError(null);
    api.getTool(slug)
      .then((data) => setTool(data.tool))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [slug]);

  return { tool, loading, error };
}